import { useState } from "react";
import { FiCopy } from "react-icons/fi";
import "../../assets/css/Custom.css";
import "../../components/common/CopyUrlButton.css";

export function CopyUrlButton({ url }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="copy-btn-wrapper">
      <button className="copy-btn" onClick={handleCopy}>
        <FiCopy size={14} />
        <span>Copy URL</span>
      </button>

      {copied && <span className="tooltip">Copied</span>}
    </div>
  );
}
